import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

// [SCS-1696] new model for pivot table
export class CompanyServiceType extends DexResourceModel {
    @Field(Number)
    public companyNumber: number = 0;
    @Field(String)
    public serviceType_uuid: string = "";
    
    @Field(Date)
    public createdAt: Date = new Date();
    @Field(Date)
    public updatedAt: Date = new Date();
    @Field(Date)
    public deletedAt: Date | null = null;	
    
    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get data(): any {
        let json = super.data;

        return json;
    }

}
